import { useEffect, useState } from "react";
import { API_URL } from "../config";

export function useImageCount({ filters, deleted }) {
  const [count, setCount] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const url = new URL(`${API_URL}/api/image_count`);
    url.searchParams.append("deleted", deleted);

    if (filters.labels?.length) url.searchParams.append("labels", filters.labels.join(","));
    if (filters.keywords?.length) url.searchParams.append("keywords", filters.keywords.join(","));
    if (filters.keywords_mode) url.searchParams.append("keywords_mode", filters.keywords_mode);

    setLoading(true);
    fetch(url.toString())
      .then((res) => res.json())
      .then((data) => {
        setCount(data.count);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching image count:", err);
        setLoading(false);
      });
  }, [filters, deleted]);

  return { count, loading };
}
